import styles from './styles.module.css';
import { Box } from '@chakra-ui/react';
import { Condition, Iteration } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import { useStockPromoState } from 'View/stock-promo/state';

const ColumnWarehouse = ({ value, values }) => {
  const { updateState } = useStockPromoState();

  const handleOpenDetailWarehouse = () => {
    updateState({
      isOpenModalDetailWarehouse: true,
      detailWarehouseData: values,
    });
  };
  return (
    <Box width={'100%'} className={styles['column__cell--warehouse']}>
      <Condition statement={value.length > 0} fallback={<TextRegular className={styles['column__warehouse--badge-text']}>-</TextRegular>}>
        <Iteration
          items={value.filter((_, index) => index < 2)}
          render={(item) => {
            const isActive = item?.storage?.status === 'Aktif';
            const background = isActive ? '#e7f1ff' : '#f1f1f1;';
            const color = isActive ? ' var(--color-primary70);' : 'var(--color-semantic-text)';

            return (
              <Box className={styles['column__warehouse--badge']} width={'100%'} background={background}>
                <TextRegular className={styles['column__warehouse--badge-text']} color={color}>
                  {item?.storage?.name}
                </TextRegular>
              </Box>
            );
          }}
        />
        <Condition statement={value.length > 2}>
          <TextSemiBold className={styles['column__warehouse--more-text']} onClick={handleOpenDetailWarehouse}>{`+${value.length - 2} lainnya`}</TextSemiBold>
        </Condition>
      </Condition>
    </Box>
  );
};

export default ColumnWarehouse;
